var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Service Image_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.6 15.8C71.9 19.6 71.8 19.6 53.2 25.8C35.6 31.6 33.9 32 25.2 32C12.3 32 12 32.3 12 48C12 62.9 12.7 64 22 64H28V74V84H32H36V74.5C36 69.3 36.3 65 36.7 65C37.1 65 45.2 67.6 54.7 70.7C71.7 76.4 71.9 76.4 73.6 80.2C75.2 83.8 75.6 84 79.7 84H84V70C84 57.3 84.2 55.8 86 54C87.3 52.7 88 50.7 88 48C88 45.3 87.3 43.3 86 42C84.2 40.2 84 38.7 84 26V12H79.7C75.6 12 75.2 12.2 73.6 15.8ZM76 48.1C76 63.8 75.7 68.1 74.8 67.7C74.1 67.5 66.9 65.1 58.8 62.4L44 57.6V48V38.5L59.3 33.3C67.6 30.5 74.8 28.1 75.3 28.1C75.7 28 76 37 76 48.1ZM36 48V56H28H20V48V40H28H36V48Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaMarketing);
export default __webpack_public_path__ + "static/media/social-media-marketing.96b42a3f03c69382147999c32e2e8b07.svg";
export { ForwardRef as ReactComponent };